module.exports = __webpack_public_path__ + "img/home_icon.cf8ae1a5.svg";